import { connectSocket, disconnectSocket } from './socket';

let started = false;
let socketRef = null;
let handlersRef = null;

export function startSortiesRealtime() {
  if (started) return;
  started = true;

  const socket = connectSocket();
  socketRef = socket;

  const notifyRefresh = () => {
    try {
      if (typeof window !== 'undefined') {
        window.dispatchEvent(new Event('sorties:refresh'));
        window.dispatchEvent(new Event('badges:refresh'));
      }
    } catch {
      // ignore
    }
  };

  handlersRef = {
    created: notifyRefresh,
    updated: notifyRefresh,
    deleted: notifyRefresh,
    createdMine: notifyRefresh,
    updatedMine: notifyRefresh,
    deletedMine: notifyRefresh,
  };

  socket.on('sortie:created', handlersRef.created);
  socket.on('sortie:updated', handlersRef.updated);
  socket.on('sortie:deleted', handlersRef.deleted);

  socket.on('sortie:created:mine', handlersRef.createdMine);
  socket.on('sortie:updated:mine', handlersRef.updatedMine);
  socket.on('sortie:deleted:mine', handlersRef.deletedMine);
}

export function stopSortiesRealtime() {
  if (!started) return;
  started = false;

  const socket = socketRef;
  const h = handlersRef;
  socketRef = null;
  handlersRef = null;

  if (socket && h) {
    try {
      socket.off('sortie:created', h.created);
      socket.off('sortie:updated', h.updated);
      socket.off('sortie:deleted', h.deleted);

      socket.off('sortie:created:mine', h.createdMine);
      socket.off('sortie:updated:mine', h.updatedMine);
      socket.off('sortie:deleted:mine', h.deletedMine);
    } catch {
      // ignore
    }
  }

  disconnectSocket();
}
